module.exports = __webpack_public_path__ + "static/media/img_overpaper3.e2d5c6ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@1x/img_overpaper3.png
// module id = 963
// module chunks = 0